import v4 from 'uuid';
import { setSessionStorage, getSessionStorage, clearSessionStorage } from '../Utils/SessionStorage';
import { getCookie, setCookie } from '../Utils/BrowserCookies';
import Role from './Role';

const ANONYMOUS_ID = 'anonymousId';
const USER_SESSION_ID = 'userSessionId';
const G2W_ENTITLEMENT = 'g2w';

export function getAnonymousId() {
  return getCookie(ANONYMOUS_ID);
}

export function setAnonymousId() {
  if (getAnonymousId()) {
    return;
  }
  setCookie(ANONYMOUS_ID, v4());
}

export function getUserSessionId() {
  return getSessionStorage(USER_SESSION_ID);
}

export function setUserSessionId() {
  if (getUserSessionId()) {
    return;
  }
  setSessionStorage(USER_SESSION_ID, v4());
}

export function clearUserSessionId() {
  clearSessionStorage(USER_SESSION_ID);
}

export function getRole(entitlements) {
  if (!Array.isArray(entitlements)) {
    return Role.UNKNOWN;
  } else if (entitlements.findIndex(item => item.toLowerCase() === G2W_ENTITLEMENT) > -1) {
    return Role.ORGANIZER;
  }
  return Role.ATTENDEE;
}



// WEBPACK FOOTER //
// ./src/Model/UserProperties.js